export default __webpack_public_path__ + "static/media/wellgo_reviewer2.2cf04aac.jpg";